module.exports = __webpack_public_path__ + "img/box23.cd673573.png";